/**
 * DevExtreme (core/version.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
module.exports = "19.2.6";



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/core/version.js
// module id = 255
// module chunks = 0